
//
const domnaHomeServiceEnquiryForm = document.querySelector('#domna-home-service-enquiry-form');

//
if (domnaHomeServiceEnquiryForm !== null) {

    //
    const script = document.createElement('script');

    //
    script.src = '//js-eu1.hsforms.net/forms/embed/v2.js';

    //
    script.onload = () => {
        if (window.hbspt) {
            window.hbspt.forms.create({

                //
                'region'   : 'eu1',
                'portalId' : '145275138',
                'formId'   : '51b3a12d-fbf6-43f7-aced-11dda91c1e4b',
                'target'   : '#domna-home-service-enquiry-form',

                //
                onFormReady: function(form) {

                    //
                    const hiddenInput = form[0].querySelector('input[name="nrla_membership_id"]');
                    const membershipNumber = domnaHomeServiceEnquiryForm.dataset.membershipNumber;

                    //
                    if (hiddenInput && membershipNumber) {
                        hiddenInput.value = membershipNumber;
                        hiddenInput.dispatchEvent(new Event('change'));
                    }

                },
            });
        }
    };

    //
    document.body.appendChild(script);

}